export default "__VITE_ASSET__ZiJ7StFk__"